import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const submitKYCContext = React.createContext({});
export let submitKYCMachine: any;

const MODULE_NAME = 'machines.submitKYC';

export const useSMsubmitKYC = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  submitKYCMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(submitKYCMachine);

  return {
    submitKYCMachine,
    submitKYCState: state,
    submitKYCSend: send,
  };
};
